import { AlertTriangle } from 'lucide-react';

interface UnmatchedSongPromptProps {
  title: string;
  artist: string;
  onChooseFromQueue: () => void;
  onLetItPlay: () => void;
}

// Bridge 1.10.0+ heard a song that isn't in the queue and moved nothing (ITER-173)
export function UnmatchedSongPrompt({ title, artist, onChooseFromQueue, onLetItPlay }: UnmatchedSongPromptProps) {
  return (
    <div
      data-testid="unmatched-song-prompt"
      className="flex flex-col gap-2 p-3 rounded-lg border border-red-300 dark:border-red-800 bg-red-50 dark:bg-red-900/20"
    >
      <p className="flex items-start gap-2 text-sm text-red-800 dark:text-red-200">
        <AlertTriangle className="w-4 h-4 flex-shrink-0 mt-0.5" />
        <span>
          Bridge can&rsquo;t find this song in your queue: <span className="font-semibold">{title} – {artist}</span>
        </span>
      </p>
      <div className="flex flex-wrap gap-2">
        <button type="button" onClick={onChooseFromQueue} className="btn btn-primary text-sm" title="Pick the queue song that's actually playing">
          Choose from queue
        </button>
        <button
          type="button"
          onClick={onLetItPlay}
          className="btn btn-secondary text-sm max-w-full"
          title={`Not in the queue: make "${title}" Now Playing and let it finish`}
        >
          <span className="truncate">Let &ldquo;{title}&rdquo; finish</span>
        </button>
      </div>
    </div>
  );
}
